export const ErrorMessage = ({ error }: { error?: string }) => {
  if (!error) return null;

  return (
    <p className="text-sm text-system-error" role="alert" aria-live="polite">
      {error}
    </p>
  );
};
